export const AgreeOptions = {
  YES: 'Yes',
  NO: 'No',
};
